// A response can carry parts of the page that are nowhere near the element being
// replaced, as <template data-replace-into="selector">. Each one is swapped into
// whatever it names, and what is left over is the markup for the element itself.
//
// Paying a proforma is the case it was written for: the strip replaces itself, and the
// items table above it comes along, because paying settles the quantities and prices on
// every row of it.
//
// Not under controllers/, where every .js file is loaded as a Stimulus definition.
export function replaceFragments(html) {
    const doc = new DOMParser().parseFromString(html, "text/html")

    doc.querySelectorAll("template[data-replace-into]").forEach(fragment => {
        const target = document.querySelector(fragment.dataset.replaceInto)

        if (target) target.outerHTML = fragment.innerHTML
        fragment.remove()
    })

    return doc.body.innerHTML
}
